<template>
  <page-option
    overflow-hidden
    titleIcon="mdi-chemical-weapon"
    :title="$t('sidebar.roles.name')"
  >
    <template #below-toolbar> </template>

    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        :api="api"
        :headers="headers"
        :params="params"
        :defaultParams="default_params"
      >
        <template v-slot:[`item.created_at`]="{ item }">
          <span>
            {{ item.created_at | dateTime('short') }}
          </span>
        </template>
        <template v-slot:[`item.updated_at`]="{ item }">
          <span>
            {{ item.updated_at | dateTime('short') }}
          </span>
        </template>
        <template v-slot:[`item.route_home`]="{ item }">
          <div v-if="item.route_home">{{ item.route_home.title || null }}</div>
        </template>
        <template #users_count="{ value }">
          {{ $n(value) }}
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <base-button-group
            class="full-width"
            :items="menus"
            :value="item"
          ></base-button-group>
        </template>
      </base-serve-table>
    </v-sheet>
  </page-option>
</template>

<script>
import { API_PERMISSION, API_ROLE } from '@api'
import { EDIT_TYPE } from '@constant'
import { ConfirmBuilder } from '@utils'

export default {
  mixins: [],
  props: { option: { type: Object, default: () => ({ params: {} }) } },
  components: {},
  data: (vm) => ({
    default_params: { with: 'permissions,users_count' },
    params: { search: '', inactive: null },
    menus: [
      {
        type: 'update',
        handler: (item) => vm.onUpdateItem(item),
      },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) => !!item.code,
      },
    ],
    headers: [
      {
        text: 'Tên vai trò',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Trang hiển thị khi đăng nhập',
        align: 'start',
        sortable: false,
        value: 'route_home',
      },
      {
        text: 'Người dùng',
        align: 'center',
        width: '150px',
        value: 'users_count',
      },
      {
        trans: 'field.updated_at',
        align: 'start',
        sortable: true,
        width: '150px',
        value: 'updated_at',
      },
      {
        trans: 'field.created_at',
        align: 'start',
        width: '150px',
        value: 'created_at',
      },
      {
        trans: 'field.action',
        value: 'action',
        sortable: false,
        width: '150px',
        align: 'center',
      },
    ],
    loading: false,
    items: [],
  }),
  watch: {},
  computed: {
    api() {
      return API_ROLE
    },
  },
  created() {},
  mounted() {
    this.getPermission()
  },
  methods: {
    onCreateItem() {
      this.$refs.dialog.open({}, EDIT_TYPE.CREATE, this.items, this.permission)
    },
    onUpdateItem(item) {
      this.$refs.dialog.openUpdate(
        item,
        EDIT_TYPE.UPDATE,
        this.items,
        this.permission
      )
    },
    onReset() {
      this.$refs.table.reload()
    },
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm.initByType('delete').setTitle('confirm.title')
      if (await confirm.confirm()) {
        const result = await API_ROLE.destroy(item.id)
        if (result && result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    async getPermission() {
      const res = await API_PERMISSION.list()
      this.permission = res.data
      this.items = res.data.map((x) => ({ text: x.display_name, value: x.id }))
    },
  },
}
</script>
